<template>
    <div id="odiv">
        <p class="p1" style="border-bottom: 1px solid #e7e7e7">审核</p>
        <div class="dela">
            <el-row :gutter="5" style="padding-bottom: 10px">
                <el-col :span="4">
                    <div class="grid-content bg-purple">入库单号：<el-input v-model="detailData.id" disabled style="width: 150px"></el-input></div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">入库日期：
                        <el-input v-model="detailData.date" disabled style="width: 150px"></el-input></div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">供应商：
                        <el-input v-model="detailData.supplier" disabled style="width: 150px"></el-input></div>
                </el-col>

                <el-col :span="4">
                    <div class="grid-content bg-purple">制单人：
                        <el-input v-model="detailData.username" disabled style="width: 150px"></el-input></div>
                </el-col>

                <el-col :span="4">
                    <div class="grid-content bg-purple" >备注：
                        <el-input v-model="detailData.remarks" disabled style="width: 150px"></el-input></div>
                </el-col>
            </el-row>

        </div>

        <el-table :data="itemList" stripe style="width: 98%;margin-left: 18px" row-key="rowkey" :header-cell-style="tableHeaderColor">
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <el-table-column prop="value" label="药品名称" width="200"></el-table-column>
            <!--<el-table-column prop="manufacturer" label="产地"></el-table-column>-->
            <el-table-column prop="unit" label="单位"></el-table-column>
            <el-table-column prop="inNumber" label="数量">

            </el-table-column>
            <el-table-column prop="retailPrice" label="零售价(￥)"></el-table-column>
            <el-table-column prop="costPrice" label="成本价(￥)">

            </el-table-column>
            <el-table-column prop="costPriceTotal" label="成本合计(￥)">

            </el-table-column>
            <el-table-column prop="batchNumber" label="批号">
            </el-table-column>
            <el-table-column prop="effectiveDates" label="有效期"></el-table-column>
        </el-table>
        <div style="margin: 10px 20px">
            <div style="width: 200px;height: 150px;float: left" v-for="item in url">
                <img :src="item.url" alt="" style="width:  100%;height:  100%" @click="openpic(item.url)">
            </div>
            <el-dialog
                    title="查看图片"
                    :visible.sync="dialogVisible"
                    width="60%">
                <img :src="pic" alt="" style="width:  100%;height:  100%">
            </el-dialog>
        </div>

        <div style="margin:50px 20px;clear: both">
            <el-button type="primary" @click="audit">审核</el-button>
            <el-button type="info" plain @click="back">返回</el-button>
        </div>
    </div>
</template>
<style  type="text/css" scoped>
    .el-button--primary {
        color: #fff;
        background-color:  rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }
    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }
    #odiv {
        width: 100%;
        height: 700px;
        background-color: white;
        /*margin: 0px 20px;*/
    }

    .dela {
        width: 100%;
        color: rgba(0, 0, 0, 0.62);
        line-height: 65px;
        font-family: 微软雅黑;
        padding-left: 18px;
    }

    .p1 {
        font-size: 20px;
        padding-left: 18px;
        color:#545754;
    }

    .p2 {
        height: 65px;
        font-size: 15px;
        padding-left: 5px;
    }

    .margintop1 div {
        margin-top: 9px;
    }

    /*.p3 {*/
        /*height: 65px;*/
        /*border-bottom: 1px solid #e7e7e7;*/
    /*}*/

    /*.p3 span {*/
        /*margin-left: 920px;*/
    /*}*/

    .margintop1 {
        margin-left: 100px;
    }


</style>
<script>
  import {formatDate} from '../../common/date';

  export default {
    data() {
      return {
        dialogVisible: false,
        pic: '',
        url: [],
        pickerOptions0: {},
        detailData: [],
        itemList: [],
        instoreID: '',
        active: true,
        num: 554,
        nowtime: formatDate(Date.now(), 'yyyy-MM-dd'),
      }
    },
    mounted: function () {
      this.instoreID = this.$route.query.id
      let instoreID = this.$route.query.id;
      this.axios(instoreID);
    },
    methods: {
      openpic: function (val) {
        this.dialogVisible = true
        this.pic = val;
      },
        tableHeaderColor({row, column, rowIndex, columnIndex}) {
            if (rowIndex === 0) {
              return "background-color:#f2f2f2;color: #a4a7af;";            }
        },
      axios: function (k) {
        if (k) {
          this.$axios({
            url: '/api/medicine/instore/' + k,
            method: 'GET',
          }).then(res => {
            this.detailData = res.data.data;
            this.itemList = res.data.data.inStoreDetailsResponses;
            this.url = JSON.parse(res.data.data.invoice);
          }).catch(err => {
            console.log(err.data);
          })
        }

      },
      audit: function () {
        console.log(this.instoreID)
        let instoreId = this.instoreID;
        this.$axios({
          url: '/api/medicine/instore/review/' + instoreId,
          method: 'PUT'
        }).then(res => {
          if (res.data.code === 200) {
            this.$message({
              type: 'success',
              message: '审核成功'
            })
            this.$router.push({path: "./intoHouse"})
          } else {
            this.$alert(res.data.msg)
          }

        }).catch(err => {
          console.log(err.data);
        })
      },
      back: function () {
        this.$router.push({path: './intoHouse'})
      }
    },


  }
</script>



// WEBPACK FOOTER //
// audit.vue?75c26fb0